var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
var HistoryComponent = /** @class */ (function (_super) {
    __extends(HistoryComponent, _super);
    function HistoryComponent(injector, translateService) {
        var _this = _super.call(this, injector) || this;
        _this.injector = injector;
        _this.translateService = translateService;
        _this.reasons = [];
        _this.translateSubscription = new Subscription();
        _this.subscription = new Subscription();
        return _this;
    }
    HistoryComponent.prototype.ngOnInit = function () {
        this.setTitle('Istoria Dream Residence în cartierul nou Rahova');
        this.meta.addTags([
            { name: 'robots', content: 'noindex' }
        ]);
        this.setMetaDescription("\n      Dream Residence s-a n\u0103scut din dorin\u021Ba de a face ceva diferit \u0219i din a crea un \u201Cacas\u0103\u201D perfect pentru fiecare rezident.\n      Ast\u0103zi g\u0103zduim locatari \u00EEn 935 de apartamente \u00EEn cartierul nou Rahova.\n    ");
    };
    return HistoryComponent;
}(SeoAwareBaseComponent));
export { HistoryComponent };



// WEBPACK FOOTER //
// ./src/app/about-us/history.component.ts.pre-build-optimizer.js